import React, {useEffect, useState} from "react";
import VkGroupWidget from "./VKWidget";
import YAWidget from "./YAWidget";
import {
    Box, Card, CardActions, CardContent,
    Container,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Link,
    Stack,
    Typography
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

function generateColorsFromBase([r, g, b], count = 5) {
  return Array.from({ length: count }, () => {
    const dr = Math.floor(Math.random() * 50) - 25;
    const dg = Math.floor(Math.random() * 50) - 25;
    const db = Math.floor(Math.random() * 50) - 25;
    return `rgb(${Math.min(255, Math.max(0, r + dr))},${Math.min(
      255,
      Math.max(0, g + dg)
    )},${Math.min(255, Math.max(0, b + db))})`;
  });
}

function generateRandomHexColor() {
  const hex = Math.floor(Math.random() * 0xffffff).toString(16);
  return `#${hex.padStart(6, "0")}`;
}

const adv = [
    {'head': 'государственная лицензия и аккредитация', 'text': '','link':''},
    {'head': 'Школа полного дня', 'text': 'Школа полного дня пребывания с 8.45 до 19.00 С 4-х разовым питанием и прогулками. Все занятия проходят в школе, Вам не придется ездить по репетиторам и кружкам','link':''},
    {'head': 'Опытная команда педагогов', 'text': 'Все сотрудники нашей школы проходят собеседования в несколько этапов, где решающим фактором являются человеческие качества и любовь к детям','link':''},
    {'head': 'питание собственного производства', 'text': 'Сбалансированное питание разработано совместно с нутрициологом','link':'/food'},
    {'head': 'программа обучения соответствует ФГОС\n', 'text': '','link':''},
    {'head': 'английский язык с первого класса\n', 'text': '','link':''},
    {'head': 'разнообразие дополнительных занятий\n', 'text': '','link':''},
]

function VideoSection() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const videoSrc = "https://tenishevaschool.ru/media/video/010924.mp4"; // Adjust path as needed

    return (
        <Container>
            {isMobile &&
                <>
                    <Typography sx={{textTransform:'uppercase'}} align={'left'} variant={'h6'} fontWeight={'bold'} >
                        ЧАСТНое общеобразовательное учреждение
                    </Typography>
                    <Typography sx={{textTransform:'uppercase'}} align={'left'} variant={'subtitle1'} fontWeight={'normal'} >
                        "школа КОМПЛЕКСНОГО РАЗВИТИЯ ДЕТЕЙ И ПОДРОСТКОв<br/>
                        С ЭЛЕМЕНТАМИ УГЛУБЛЕННОГО ИЗУЧЕНИЯ НАУК
                        И ТЕХНОЛОГИЙ <br/> ИМ. М. К. ТЕНИШЕВОЙ"
                    </Typography>
                </>
            }
            <ImageList cols={1} gap={8} sx={{mt: 2}}>
                <ImageListItem>
                    <video width="100%" id="bgVideo" autoPlay loop muted playsInline>
                        <source src={videoSrc} type="video/mp4"/>
                    </video>
                    {!isMobile &&<ImageListItemBar
                        sx={{ marginTop:'22%',background:'linear-gradient(to bottom, rgba(0,0,0,0.0) 0%,rgba(0,0,0,0.1) 70%, rgba(0,0,0,0) 100%)'}}
                        position="top"
                        title={<>
                            <Typography sx={{textTransform:'uppercase'}} align={'center'} variant={isMobile ? 'caption':'h5'} fontWeight={'bold'} >
                                ЧАСТНое общеобразовательное учреждение
                            </Typography>
                            <Typography sx={{textTransform:'uppercase'}} align={'center'} variant={isMobile ? 'caption':'h6'} fontWeight={'normal'} >
                                "школа КОМПЛЕКСНОГО РАЗВИТИЯ ДЕТЕЙ И ПОДРОСТКОв<br/>
                                С ЭЛЕМЕНТАМИ УГЛУБЛЕННОГО ИЗУЧЕНИЯ НАУК
                                И ТЕХНОЛОГИЙ <br/> ИМ. М. К. ТЕНИШЕВОЙ"
                            </Typography>
                        </>
                        }
                        subtitle={''}
                    />}
                </ImageListItem>
            </ImageList>

            <Box mt={2} mb={2}>
                {adv.map((adv, index) => (
                    <Card key={index} sx={{mt: 1}}>
                        <CardContent>
                            <Typography variant={isMobile ? 'h6': 'h5'} fontWeight={'bold'} gutterBottom sx={{color: generateRandomHexColor(), textTransform: 'uppercase'}}>
                                <CheckIcon /> {adv.head}</Typography>
                            <Typography variant={isMobile ? 'body1': 'h6'}  gutterBottom >
                                {adv.text}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            {adv.link && <Link href={adv.link} underline="hover">Подробнее</Link>}
                        </CardActions>
                    </Card>
                ))
                }
            </Box>
            <Box>
                <Stack direction={isMobile? "column":"row"} spacing={2} justifyContent="center" alignItems="center" mt={2}>
                    <VkGroupWidget/>
                    <YAWidget/>
                </Stack>
            </Box>
        </Container>
    );
}

export default VideoSection;
